// Copy for /tell-me-more (EN) and /sk/tell-me-more (SK).
const en = {
  seoTitle: 'Talk to Us | Stratodata',
  seoDescription: "Tell us where it hurts and we'll walk you through it — send a message or grab a slot directly on our calendar.",
  title: "Let's talk it through",
  subtitle: 'Send us a few details, or skip straight to a slot on our calendar — whichever gets you an answer faster.',
  calendarTitle: 'Pick a 30-minute slot',
  calendarText: 'See live availability and book directly on our calendar.',
  calendarButton: 'Open the calendar',
};

const sk: typeof en = {
  seoTitle: 'Porozprávajme sa | Stratodata',
  seoDescription: 'Povedzte nám, čo vás trápi, a spoločne to prejdeme. Napíšte nám alebo si rovno vyberte termín v našom kalendári.',
  title: 'Váš ďalší krok začína tu',
  subtitle: 'Napíšte nám pár riadkov alebo si rovno vyberte termín v kalendári. Zvoľte to, čo vám viac vyhovuje.',
  calendarTitle: 'Vyberte si 30-minútový termín',
  calendarText: 'Pozrite si aktuálne voľné termíny a rezervujte si hovor priamo v našom kalendári.',
  calendarButton: 'Otvoriť kalendár',
};

export const tellMeMoreCopy = { en, sk };
